<div class="ibox detailed-view-ibox" *ngIf="settingsParkingPassesService.showDetailedView && settingsParkingPassesService.selectedItemData">
    <div class="detailed-view-header">
        <span *ngIf="settingsParkingPassesService.selectedItemData.enableStatus"
              class="text-uppercase label label-active">Active</span>
        <span *ngIf="!settingsParkingPassesService.selectedItemData.enableStatus"
              class="text-uppercase label label-inactive">Inactive</span>
        <div class="detailed-view-amenity-name">{{settingsParkingPassesService.selectedItemData.name}}</div>
        <span class="close-detailed-view" (click)="settingsParkingPassesService.toggleDetailedView(null, false)">×</span>
    </div>
    <div *ngIf="settingsParkingPassesService.currentTabId == 'rules'">
        <div class="detailed-view-body">
            <div class="detailed-view__more-info m-t-md">
                <form #form="ngForm"
                      [ngClass]="{'ng-submitted': form.submitted}"
                      autocomplete="off">
                    <div>
                        <div class="detailed-view-navigation">
                            <div class="col-md-3 col-sm-3 col-xs-3 no-padding">
                                <div class="button-section"
                                     (click)="navPosition = 'general';"
                                     [ngStyle]="{'background-color': navPosition == 'general' ? '#ebebeb' : ''}">
                                    General
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-3 col-xs-3 no-padding">
                                <div class="button-section"
                                     (click)="navPosition = 'notifications';"
                                     [ngStyle]="{'background-color': navPosition == 'notifications' ? '#ebebeb' : ''}">
                                    Notifications
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-3 col-xs-3 no-padding">
                                <div class="button-section"
                                     (click)="navPosition = 'terms';"
                                     [ngStyle]="{'background-color': navPosition == 'terms' ? '#ebebeb' : ''}">
                                    Terms
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-3 col-xs-3 no-padding">
                                <div class="button-section"
                                     (click)="navPosition = 'schedule';"
                                     [ngStyle]="{'background-color': navPosition == 'schedule' ? '#ebebeb' : ''}">
                                    Passes
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="general-tab" *ngIf="navPosition == 'general'">
                        <input-field name="name"
                                     [ngModel]="settingsParkingPassesService.selectedItemData.name"
                                     [title]="'Name'"
                                     [tooltipText]="'Name'"
                                     (update)="onSubmit({name: form.value.name})">
                        </input-field>
                        <input-field name="internalId"
                                     [ngModel]="settingsParkingPassesService.selectedItemData.internalId"
                                     [title]="'Internal ID'"
                                     [tooltipText]="'Internal ID'"
                                     (update)="onSubmit({internalId: form.value.internalId})">
                        </input-field>
                        <hr>
                        <div class="settings-amenities-slider-container">
                            <span>Status</span>
                            <mat-slide-toggle name="status"
                                              (change)="onSubmit({enableStatus: form.value.status ? 1 : 0})"
                                              title="{{!settingsParkingPassesService.selectedItemData.passTypes.length ?
                                                       'Setup the pass type of this rule to make switch active' : ''}}"
                                              [disabled]="!settingsParkingPassesService.selectedItemData.passTypes.length"
                                              [ngModel]="settingsParkingPassesService.selectedItemData.enableStatus">
                            </mat-slide-toggle>
                        </div>
                        <hr>
                        <div class="settings-amenities-slider-container">
                            <span>Allow Residents To Book</span>
                            <mat-slide-toggle name="allowResidentsToBook"
                                              (change)="onSubmit({allowResidentsToBook: form.value.allowResidentsToBook})"
                                              [ngModel]="settingsParkingPassesService.selectedItemData.allowResidentsToBook">
                            </mat-slide-toggle>
                        </div>
                        <hr>
                        <div class="m-b-xs" style="font-weight: bold;"><span>Applies To Parking Lots</span></div>
                        <multiselect-field name="parkingLots"
                                           [data]="settingsParkingPassesService.parkingLotsInMultiselectFormat"
                                           [blankError]="'Lots should not be blank.'"
                                           [(ngModel)]="settingsParkingPassesService.selectedItemFormattedLotsArray"
                                           (update)="onSubmit({lotRule: parkingPassLotsFormatConvertion(form.value.parkingLots)})">
                        </multiselect-field>
                        <div class="row delete-amenity-button btn-in-table"
                             *ngIf="settingsParkingPassesService.canDelete()">
                            <button class="btn submit" type="button" (click)="deleteSelected()">
                                Delete Parking Rule
                            </button>
                        </div>
                    </div>
                    <div *ngIf="navPosition == 'notifications'">
                        <div class="settings-amenities-slider-container">
                            <span>Notify Staff</span>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       [(ngModel)]="settingsParkingPassesService.passCreatedStaffCheckbox"
                                       [disabled]="!emailTemplateIsSet('staff', 'created')"
                                       name="passCreatedStaffCheckbox"
                                       id="passCreatedStaffCheckbox"
                                       (change)="submitNotificationsField()">
                                <label for="passCreatedStaffCheckbox"
                                       [title]="!emailTemplateIsSet('staff', 'created') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('staff', 'created')">
                                Pass Created
                            </span>
                        </div>
                        <div class="m-b-xs" *ngIf="settingsParkingPassesService.passCreatedStaffCheckbox">
                            <multiselect-field name="passCreatedStaffMultiselect"
                                               [data]="settingsParkingPassesService.userRoles"
                                               [(ngModel)]="settingsParkingPassesService.createdStaffMultiselectArray"
                                               (update)="submitNotificationsField()">
                            </multiselect-field>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       [(ngModel)]="settingsParkingPassesService.passApprovedStaffCheckbox"
                                       [disabled]="!emailTemplateIsSet('staff', 'approved')"
                                       name="passApprovedStaffCheckbox"
                                       id="passApprovedStaffCheckbox"
                                       (change)="submitNotificationsField()">
                                <label for="passApprovedStaffCheckbox"
                                       [title]="!emailTemplateIsSet('staff', 'approved') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('staff', 'approved')">
                                Pass Approved
                            </span>
                        </div>
                        <div class="m-b-xs" *ngIf="settingsParkingPassesService.passApprovedStaffCheckbox">
                            <multiselect-field name="passApprovedStaffMultiselect"
                                               [data]="settingsParkingPassesService.userRoles"
                                               [(ngModel)]="settingsParkingPassesService.approvedStaffMultiselectArray"
                                               (update)="submitNotificationsField()">
                            </multiselect-field>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       [(ngModel)]="settingsParkingPassesService.passDeclinedStaffCheckbox"
                                       [disabled]="!emailTemplateIsSet('staff', 'declined')"
                                       name="passDeclinedStaffCheckbox"
                                       id="passDeclinedStaffCheckbox"
                                       (change)="submitNotificationsField()">
                                <label for="passDeclinedStaffCheckbox"
                                       [title]="!emailTemplateIsSet('staff', 'declined') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('staff', 'declined')">
                                Pass Declined
                            </span>
                        </div>
                        <div class="m-b-xs" *ngIf="settingsParkingPassesService.passDeclinedStaffCheckbox">
                            <multiselect-field name="passDeclinedStaffMultiselect"
                                               [data]="settingsParkingPassesService.userRoles"
                                               [(ngModel)]="settingsParkingPassesService.declinedStaffMultiselectArray"
                                               (update)="submitNotificationsField()">
                            </multiselect-field>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       [(ngModel)]="settingsParkingPassesService.passRequestStaffCheckbox"
                                       [disabled]="!emailTemplateIsSet('staff', 'request')"
                                       name="passRequestStaffCheckbox" id="passRequestStaffCheckbox"
                                       (change)="submitNotificationsField()">
                                <label for="passRequestStaffCheckbox"
                                       [title]="!emailTemplateIsSet('staff', 'request') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('staff', 'request')">
                                Pass Request
                            </span>
                        </div>
                        <div class="m-b-xs" *ngIf="settingsParkingPassesService.passRequestStaffCheckbox">
                            <multiselect-field name="passRequestStaffMultiselect"
                                               [data]="settingsParkingPassesService.userRoles"
                                               [(ngModel)]="settingsParkingPassesService.requestStaffMultiselectArray"
                                               (update)="submitNotificationsField()">
                            </multiselect-field>
                        </div>
                        <hr>
                        <div class="settings-amenities-slider-container">
                            <span>Notify Residents</span>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       id="passCreatedResidentCheckbox"
                                       name="passCreatedResidentCheckbox"
                                       [(ngModel)]="settingsParkingPassesService.passCreatedResidentCheckbox"
                                       [disabled]="!emailTemplateIsSet('residents', 'created')"
                                       (change)="submitNotificationsField()">
                                <label for="passCreatedResidentCheckbox"
                                       [title]="!emailTemplateIsSet('residents', 'created') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('residents', 'created')">
                                Pass Created
                            </span>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       id="passApprovedResidentCheckbox"
                                       name="passApprovedResidentCheckbox"
                                       [(ngModel)]="settingsParkingPassesService.passApprovedResidentCheckbox"
                                       [disabled]="!emailTemplateIsSet('residents', 'approved')"
                                       (change)="submitNotificationsField()">
                                <label for="passApprovedResidentCheckbox"
                                       [title]="!emailTemplateIsSet('residents', 'approved') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('residents', 'approved')">Pass Approved</span>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       id="passDeclinedResidentCheckbox"
                                       name="passDeclinedResidentCheckbox"
                                       [(ngModel)]="settingsParkingPassesService.passDeclinedResidentCheckbox"
                                       [disabled]="!emailTemplateIsSet('residents', 'declined')"
                                       (change)="submitNotificationsField()">
                                <label for="passDeclinedResidentCheckbox"
                                       [title]="!emailTemplateIsSet('residents', 'declined') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('residents', 'declined')">
                                Pass Declined
                            </span>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       id="passRequestResidentCheckbox"
                                       name="passRequestResidentCheckbox"
                                       [(ngModel)]="settingsParkingPassesService.passRequestResidentCheckbox"
                                       [disabled]="!emailTemplateIsSet('residents', 'request')"
                                       (change)="submitNotificationsField()">
                                <label for="passRequestResidentCheckbox"
                                       [title]="!emailTemplateIsSet('residents', 'request') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('residents', 'request')">
                                Pass Request
                            </span>
                        </div>
                    </div>
                    <div class="terms-tab" *ngIf="navPosition == 'terms'">
                        <div class="settings-amenities-slider-container">
                            <span class="mtv-primary-color clickable-text"
                                  (click)="settingsParkingPassesService.isLegalAgreementModalShow = true;">
                                Legal Agreement
                            </span>
                            <mat-slide-toggle name="legalAgreementStatus"
                                              (change)="onSubmit({legalAgreementStatus: form.value.legalAgreementStatus ? 1 : 0})"
                                              [ngModel]="settingsParkingPassesService.selectedItemData.legalAgreementStatus">
                            </mat-slide-toggle>
                        </div>
                        <!-- ___ Hide From Staff Interface ___ -->
                        <div class="row m-b-sm col-md-12">
                            <label class="img-checkbox no-decoration">
                                <input id="legalAgreementHideFromStaffInterface"
                                       type="checkbox"
                                       name="legalAgreementHideFromStaffInterface"
                                       [disabled]="noEdit" #legalAgreementHideFromStaffInterface
                                       [ngModel]="settingsParkingPassesService.selectedItemData.legalAgreementHideFromStaffInterface"
                                       (change)="onSubmit({legalAgreementHideFromStaffInterface: form.value.legalAgreementHideFromStaffInterface ? 1: 0})">
                                <label for="legalAgreementHideFromStaffInterface"><svg-checked></svg-checked></label>
                                <span>Hide From Staff Interface</span>
                            </label>
                        </div>
                        <div class="settings-amenities-slider-container">
                            <span class="mtv-primary-color clickable-text"
                                  (click)="settingsParkingPassesService.isDisclaimerModalShow = true;">
                                Disclaimer
                            </span>
                            <mat-slide-toggle name="disclaimerStatus"
                                              (change)="onSubmit({disclaimerStatus: form.value.disclaimerStatus ? 1 : 0})"
                                              [ngModel]="settingsParkingPassesService.selectedItemData.disclaimerStatus">
                            </mat-slide-toggle>
                        </div>
                        <!-- ___ Hide From Staff Interface ___ -->
                        <div class="row m-b-sm col-md-12">
                            <label class="img-checkbox no-decoration">
                                <input id="disclaimerHideFromStaffInterface"
                                       type="checkbox"
                                       name="disclaimerHideFromStaffInterface"
                                       [disabled]="noEdit" #disclaimerHideFromStaffInterface
                                       [ngModel]="settingsParkingPassesService.selectedItemData.disclaimerHideFromStaffInterface"
                                       (change)="onSubmit({disclaimerHideFromStaffInterface: form.value.disclaimerHideFromStaffInterface ? 1: 0})">
                                <label for="disclaimerHideFromStaffInterface"><svg-checked></svg-checked></label>
                                <span>Hide From Staff Interface</span>
                            </label>
                        </div>
                        <div class="settings-amenities-slider-container">
                            <span class="mtv-primary-color clickable-text"
                                  (click)="settingsParkingPassesService.isDisclaimerModalShow = true;">
                                Printed Disclaimer
                            </span>
                            <mat-slide-toggle name="disclaimerStatus"
                                              (change)="onSubmit({disclaimerStatus: form.value.disclaimerStatus ? 1 : 0})"
                                              [ngModel]="settingsParkingPassesService.selectedItemData.disclaimerStatus">
                            </mat-slide-toggle>
                        </div>
                        <!--<div class="settings-amenities-slider-container">-->
                            <!--<span>Payments</span>-->
                        <!--</div>-->
                        <!--&lt;!&ndash; ___ Accept Cheques  ___ &ndash;&gt;-->
                        <!--<div class="row m-b-sm col-md-12">-->
                            <!--<label class="img-checkbox no-decoration">-->
                                <!--<input id="acceptCheques" type="checkbox" name="acceptCheques"-->
                                       <!--[ngModel]="settingsParkingPassesService.selectedItemData.acceptCheques"-->
                                       <!--(change)="paymentMethodSubmit({acceptCheques: form.value.acceptCheques ? 1: 0})"-->
                                       <!--[disabled]="!ifAnyPassTypeHasFee() || noEdit">-->
                                <!--<label for="acceptCheques"><svg-checked></svg-checked></label>-->
                                <!--<span>Accept Cheques</span>-->
                            <!--</label>-->
                        <!--</div>-->
                        <!--&lt;!&ndash; ___ Accept Credit Cards  ___ &ndash;&gt;-->
                        <!--<div class="row m-b-sm col-md-12">-->
                            <!--<label class="img-checkbox no-decoration">-->
                                <!--<input id="acceptCreditCards" type="checkbox" name="acceptCreditCards"-->
                                       <!--[ngModel]="settingsParkingPassesService.selectedItemData.acceptCreditCards"-->
                                       <!--(change)="paymentMethodSubmit({acceptCreditCards: form.value.acceptCreditCards ? 1: 0})"-->
                                       <!--[disabled]="!ifAnyPassTypeHasFee() || noEdit">-->
                                <!--<label for="acceptCreditCards"><svg-checked></svg-checked></label>-->
                                <!--<span>Accept Credit Cards</span>-->
                            <!--</label>-->
                        <!--</div>-->
                        <!--&lt;!&ndash; ___ Accept Cash  ___ &ndash;&gt;-->
                        <!--<div class="row m-b-sm col-md-12">-->
                            <!--<label class="img-checkbox no-decoration">-->
                                <!--<input id="acceptCash" type="checkbox" name="acceptCash"-->
                                       <!--[ngModel]="settingsParkingPassesService.selectedItemData.acceptCash"-->
                                       <!--(change)="paymentMethodSubmit({acceptCash: form.value.acceptCash ? 1: 0})"-->
                                       <!--[disabled]="!ifAnyPassTypeHasFee() || noEdit">-->
                                <!--<label for="acceptCash"><svg-checked></svg-checked></label>-->
                                <!--<span>Accept Cash</span>-->
                            <!--</label>-->
                        <!--</div>-->
                        <!--<div class="row m-b-xs m-t-md" (dblclick)="settingsParkingPassesService.selectedItemData.isCanEdit && setEditModeFor(settingsParkingPassesService.selectedItemData, 'defaultPaymentMethod', true)">-->
                            <!--<div class="col-sm-5" style="font-weight: bold;">Default Payment Method</div>-->
                            <!--<div class="col-sm-7"-->
                                 <!--*ngIf="!settingsParkingPassesService.selectedItemData.formFields.defaultPaymentMethod.editMode">-->
                                <!--<span class="text-capitalize">-->
                                    <!--{{settingsParkingPassesService.selectedItemData.defaultPaymentMethod ?-->
                                    <!--settingsParkingPassesService.selectedItemData.defaultPaymentMethod.replace('_', ' ') : '-'}}-->
                                <!--</span>-->

                                <!--<i *ngIf="settingsParkingPassesService.selectedItemData.isCanEdit" class="fa fa-pencil pull-right"-->
                                   <!--(click)="setEditModeFor(settingsParkingPassesService.selectedItemData, 'defaultPaymentMethod', true)"-->
                                   <!--data-toggle="tooltip" data-placement="top" title="Edit"></i>-->
                            <!--</div>-->
                            <!--<div class="dv-value-edit col-sm-7" *ngIf="settingsParkingPassesService.selectedItemData.formFields.defaultPaymentMethod.editMode">-->
                                <!--<select class="form-control" name="defaultPaymentMethod"-->
                                        <!--[ngModel]="settingsParkingPassesService.selectedItemData.defaultPaymentMethod">-->
                                    <!--<option value="" hidden></option>-->
                                    <!--<option *ngIf="settingsParkingPassesService.selectedItemData.acceptCheques"-->
                                            <!--value="cheque">Cheque</option>-->
                                    <!--<option *ngIf="settingsParkingPassesService.selectedItemData.acceptCreditCards"-->
                                            <!--value="credit_card">Credit Card</option>-->
                                    <!--<option *ngIf="settingsParkingPassesService.selectedItemData.acceptCash"-->
                                            <!--value="cash">Cash</option>-->
                                <!--</select>-->

                                <!--<button type="button" (click)="onSubmit({defaultPaymentMethod: form.value.defaultPaymentMethod})">-->
                                    <!--<i class="fa fa-check"></i>-->
                                <!--</button>-->

                                <!--<button type="button" (click)="setEditModeFor(settingsParkingPassesService.selectedItemData, 'defaultPaymentMethod', false)">-->
                                    <!--<i class="fa fa-times"></i>-->
                                <!--</button>-->
                            <!--</div>-->
                        <!--</div>-->
                    </div>
                    <div class="schedule-tab" *ngIf="navPosition == 'schedule'">
                        <div class="m-t-xs">
                            <settings-amenity-restrictions-field
                                name="minIntervalBetweenBooking"
                                [ngModel]="isRestrictionsStringValid(settingsParkingPassesService.selectedItemData.minIntervalBetweenBooking) ?
                                    {number: +settingsParkingPassesService.selectedItemData.minIntervalBetweenBooking.split(' ')[0],
                                     selectValue: settingsParkingPassesService.selectedItemData.minIntervalBetweenBooking.split(' ')[1]} :
                                    {number: null, selectValue: ''}"
                                [selectValues]="timeIntervals"
                                [title]="'Min Interval Between Booking'"
                                (update)="onRestrictionsFieldSubmit(form.value.minIntervalBetweenBooking.number, form.value.minIntervalBetweenBooking.selectValue, 'minIntervalBetweenBooking')">
                            </settings-amenity-restrictions-field>
                        </div>

                        <div class="m-t-xs">
                            <settings-amenity-restrictions-field
                                name="maxBookingsPerSuiteCount"
                                [ngModel]="{number: +settingsParkingPassesService.selectedItemData.maxBookingsPerSuiteCount,
                                            selectValue: settingsParkingPassesService.selectedItemData.maxBookingsPerSuiteSequenceType}"
                                [selectValues]="timeIntervalsPer"
                                [title]="'Max Booking Per Suite'"
                                (update)="onRestrictionsFieldSubmit(form.value.maxBookingsPerSuiteCount.number, form.value.maxBookingsPerSuiteCount.selectValue, 'maxBookingsPerSuiteCount')">
                            </settings-amenity-restrictions-field>
                        </div>

                        <div class="m-t-xs">
                            <settings-amenity-restrictions-field
                                name="maxBookingsPerLicensePlate"
                                [ngModel]="{number: +settingsParkingPassesService.selectedItemData.maxBookingsPerLicensePlateCount,
                                            selectValue: settingsParkingPassesService.selectedItemData.maxBookingsPerLicensePlateSequenceType}"
                                [selectValues]="timeIntervalsPer"
                                [title]="'Max Booking Per License Plate'"
                                (update)="onRestrictionsFieldSubmit(form.value.maxBookingsPerLicensePlate.number, form.value.maxBookingsPerLicensePlate.selectValue, 'maxBookingsPerLicensePlate')">
                            </settings-amenity-restrictions-field>
                        </div>

                        <input-field name="maxPassCountPerBooking"
                                     [ngModel]="settingsParkingPassesService.selectedItemData.maxPassCountPerBooking"
                                     [title]="'Max # of Passes Per Booking'"
                                     [longTitle]="true"
                                     [isNumber]="true"
                                     [tooltipText]="'Max # of Passes Per Booking'"
                                     (update)="onSubmit({maxPassCountPerBooking: form.value.maxPassCountPerBooking})">
                        </input-field>

                        <div class="row delete-amenity-button btn-in-table"
                             *ngIf="settingsParkingPassesService.canEdit() &&
                                    (settingsParkingPassesService.selectedItemData.type == 'general' ||
                                    settingsParkingPassesService.selectedItemData.passTypes.length < 1)">
                            <button class="btn submit" type="button" (click)="showPassTypeModal()">
                                Add Pass Type
                            </button>
                        </div>
                        <div class="settings-parking-rule-types-header"
                             *ngIf="settingsParkingPassesService.selectedItemData.passTypes.length > 0">
                            <span>Parking Pass Type</span>
                            <span>Active</span>
                        </div>
                        <div class="settings-amenities-slider-container"
                             *ngFor="let type of settingsParkingPassesService.selectedItemData.passTypes">
                            <span class="mtv-primary-color clickable-text" (click)="showPassTypeModal(type)">
                                {{type.name}}
                                <i class="fa fa-trash delete-pass-type-icon"
                                   (click)="deletePassType($event, type)"
                                   title="Delete Pass Type"></i>
                            </span>
                            <mat-slide-toggle name="status{{type.id}}"
                                              (change)="changePassTypeEnabledStatus(type.id, form.value['status' + type.id] ? 1 : 0)"
                                              [ngModel]="type.enableStatus">
                            </mat-slide-toggle>
                        </div>
                        <div class="settings-parking-rule-types-header"
                             *ngIf="settingsParkingPassesService.selectedItemData.passTypes.length > 1">
                            <span>Combined Limits</span>
                            <i class="fa fa-2x fa-plus pull-right mtv-primary-color"
                               (click)="addLimitGroup()"
                               title="Add New Limit"></i>
                        </div>
                        <div *ngFor="let group of settingsParkingPassesService.selectedItemData.limitGroups; let index = index">
                            <multiselect-with-select-field
                                name="limitedPassTypes{{index}}"
                                [data]="settingsParkingPassesService.selectedItemFormattedPassesArray"
                                [(ngModel)]="settingsParkingPassesService.selectedItemData.limitGroups[index]"
                                (update)="submitLimitGroups()"
                                (delete)="removeLimitGroup(index)">
                            </multiselect-with-select-field>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div *ngIf="settingsParkingPassesService.currentTabId == 'lots'">
        <form #form="ngForm" submittable autocomplete="off">
            <div class="detailed-view-body">
                <div class="detailed-view__more-info m-t-md">
                    <div class="general-tab">
                        <input-field name="name"
                                     [ngModel]="settingsParkingPassesService.selectedItemData.name"
                                     [title]="'Name'"
                                     [tooltipText]="'Name'"
                                     (update)="onSubmit({name: form.value.name})">
                        </input-field>
                        <input-field name="internalId"
                                     [ngModel]="settingsParkingPassesService.selectedItemData.internalId"
                                     [title]="'Internal ID'"
                                     [tooltipText]="'Internal ID'"
                                     (update)="onSubmit({internalId: form.value.internalId})">
                        </input-field>
                        <hr>
                        <div class="settings-amenities-slider-container">
                            <span>Status</span>
                            <mat-slide-toggle name="status"
                                              (change)="onSubmit({enableStatus: form.value.status ? 1 : 0})"
                                              [ngModel]="settingsParkingPassesService.selectedItemData.enableStatus">
                            </mat-slide-toggle>
                        </div>
                        <div class="m-b-xs" style="font-weight: bold;"><span>Available in Buildings</span></div>
                        <multiselect-field
                            name="availableBuldings"
                            [data]="settingsParkingPassesService.buldingsInMultiselectFormat"
                            [amenityBuildingSelect]="true"
                            [(ngModel)]="settingsParkingPassesService.selectedItemFormattedBuildingsArray"
                            (update)="onSubmit({building: buildingParkingPassLotsFormatConvertion(form.value.availableBuldings)})">
                        </multiselect-field>
                        <div class="row delete-amenity-button btn-in-table" *ngIf="settingsParkingPassesService.canDelete()">
                            <button class="btn submit" type="button" (click)="deleteSelected()">
                                Delete Parking Lot
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-parking-passes/settings-parking-passes-detailed-view/settings-parking-passes-detailed-view.component.html